// Administration → Roles (pages/Administration.tsx's rail, admin/Roles.tsx,
// admin/permissionBoxes.tsx), in the three languages a branch in Azerbaijan
// works in.
// Native review pending (az, ru). Phrases added in the 2026-10 redesign are
// English only (empty az/ru), while the product is English only.
import type { Phrase } from '../staffText'

export const roles = {
  // pages/Administration.tsx's rail
  'admin.section.roles': { en: 'Roles', az: 'Rollar', ru: 'Роли' },
  'admin.also.roles': { en: 'permissions access control', az: 'icazələr giriş nəzarət', ru: 'права доступ контроль' },

  // admin/Roles.tsx
  'admin.roles.title': { en: 'Roles', az: 'Rollar', ru: 'Роли' },
  'admin.roles.new': { en: 'New role', az: 'Yeni rol', ru: 'Новая роль' },
  'admin.roles.name': { en: 'Name', az: 'Ad', ru: 'Название' },
  'admin.roles.holders': { en: '{n} user|{n} users', az: '{n} nəfər', ru: '{n} человек|{n} человека|{n} человек' },
  'admin.roles.delete': { en: 'Delete', az: 'Sil', ru: 'Удалить' },
  'admin.roles.deleteAsk': { en: 'Delete this role?', az: 'Bu rol silinsin?', ru: 'Удалить эту роль?' },
  'admin.roles.deleted': { en: 'Deleted.', az: 'Silindi.', ru: 'Удалено.' },
  'admin.roles.none': { en: 'No roles yet.', az: '', ru: '' },
  'admin.roles.col.role': { en: 'Role', az: '', ru: '' },
  'admin.roles.col.people': { en: 'Users', az: '', ru: '' },
  'admin.roles.col.access': { en: 'Access', az: '', ru: '' },
  'admin.roles.everything': { en: 'Everything', az: '', ru: '' },
  'admin.roles.nothing': { en: 'No screens', az: '', ru: '' },
  'admin.roles.locked': { en: 'Holds every permission. Fixed.', az: 'Bütün icazələrə malikdir. Dəyişilmir.', ru: 'Включает все права. Изменить нельзя.' },

  // admin/permissionBoxes.tsx: the three groups
  'admin.roles.group.daily': { en: 'Daily work', az: 'Gündəlik iş', ru: 'Ежедневная работа' },
  'admin.roles.group.manage': { en: 'Management', az: 'İdarəetmə', ru: 'Управление' },
  'admin.roles.group.settings': { en: 'Settings', az: 'Ayarlar', ru: 'Настройки' },

  // admin/permissionBoxes.tsx: one tick box per screen (org.Screens' keys)
  'admin.roles.screen.counter': { en: 'Counter', az: 'Pəncərə', ru: 'Окно' },
  'roles.builtin.admin': { en: 'Administrator', az: 'Administrator', ru: 'Администратор' },
  'roles.builtin.branchManager': { en: 'Branch manager', az: 'Filial rəhbəri', ru: 'Руководитель отделения' },
  'roles.builtin.supervisor': { en: 'Supervisor', az: 'Nəzarətçi', ru: 'Супервайзер' },
  'roles.builtin.counter': { en: 'Counter', az: 'Pəncərə əməkdaşı', ru: 'Сотрудник окна' },
  'roles.builtin.reception': { en: 'Reception', az: 'Qəbul əməkdaşı', ru: 'Сотрудник ресепшн' },
  'admin.roles.screen.reception': { en: 'Reception', az: 'Qəbul', ru: 'Ресепшн' },
  'admin.roles.screen.floor': { en: 'Live dashboard', az: 'Zal', ru: 'Зал' },
  'admin.roles.screen.reports': { en: 'Reports', az: 'Hesabatlar', ru: 'Отчёты' },
  'admin.roles.screen.audit': { en: 'Audit trail', az: 'Audit', ru: 'Аудит' },
  'admin.roles.screen.appointments': { en: 'Appointments', az: 'Bronlar', ru: 'Записи' },
  'admin.roles.screen.approvals': { en: 'Approvals', az: 'Təsdiqlər', ru: 'Согласования' },
  'admin.roles.screen.vipCall': { en: 'Call out of turn', az: '', ru: '' },
  'admin.roles.screen.signage': { en: 'Signage', az: 'Reklam', ru: 'Реклама' },
  'admin.roles.screen.catalogue': { en: 'Services and queues', az: 'Xidmətlər və növbələr', ru: 'Услуги и очереди' },
  'admin.roles.screen.profiles': { en: 'Operation profiles', az: 'Əməliyyat profilləri', ru: 'Операционные профили' },
  'admin.roles.screen.branches': { en: 'Branches', az: 'Filiallar', ru: 'Отделения' },
  'admin.roles.screen.layouts': { en: 'Designs', az: 'Dizaynlar', ru: 'Макеты' },
  'admin.roles.screen.people': { en: 'Users and roles', az: 'Əməkdaşlar və rollar', ru: 'Сотрудники и роли' },
  'admin.roles.screen.onlineBooking': { en: 'Online booking', az: 'Onlayn növbə', ru: 'Онлайн-запись' },
  'admin.roles.screen.licence': { en: 'Licence', az: 'Lisenziya', ru: 'Лицензия' },
} satisfies Record<string, Phrase>
